export const productCardKeywords = {
    showKeywords: {
        type: Boolean,
        default: true,
    }
}